import React from "react";
import styled from "styled-components";


function WidgetsDataCardWithCharts() {
  return <WidgetsDataCardWithCharts1></WidgetsDataCardWithCharts1>;
}

const WidgetsDataCardWithCharts1 = styled.div`
  position: absolute;
  width: 400px;
  height: 228px;
  top: 0;
  left: 0;
  background-color: var(--white);
  border-radius: 30px;
  box-shadow: 4px 4px 28px #6bd9dafc;
`;

export default WidgetsDataCardWithCharts;
